enum EBillingEmailType {
    PRIMARY_EMAIL = 'PRIMARY_EMAIL',
    ALTERNATIVE_EMAIL = 'ALTERNATIVE_EMAIL'
}

export default EBillingEmailType;